module.exports = __webpack_public_path__ + "img/header-diamondJewelryGold.ea0de62.jpg";